export default [
  'name',
  'club',
  'address',
  'email',
  'status',
  { key: 'user', label: 'Owner', sorter: false },
  { key: 'action', label: '' }
]
